import { useMemo } from 'react';
import { AtlassianProductsFragment$data } from 'graphql/__generated__/AtlassianProductsFragment.graphql';
import { productIdToNodeIdChangeIsActive } from 'services/statsig/featureGates';

export type ProductData =
  | readonly ({
      readonly cursor: string | null;
      readonly node: {
        readonly id: string;
        readonly title: string | null;
        readonly type: string | null;
        readonly viewHref: string | null;
      } | null;
    } | null)[]
  | null
  | undefined;

export type NormalizedProduct = {
  readonly id: string;
  readonly title: string | null;
  readonly type: string | null;
  readonly viewHref: string | null;
};

const getNormalizedProducts = (
  allProducts: AtlassianProductsFragment$data,
  isProductIdToNodeIdChangeEnabled: boolean,
): NormalizedProduct[] => {
  const edges = allProducts.edges ?? [];

  return edges.reduce<NormalizedProduct[]>(
    (normalizedProducts, currentEdge) => {
      if (currentEdge?.node) {
        const normalizedProduct = {
          title: currentEdge.node.title,
          type: currentEdge.node.type,
          viewHref: currentEdge.node.viewHref,
          id: isProductIdToNodeIdChangeEnabled
            ? currentEdge.node.productId
            : currentEdge.node.id,
        };

        normalizedProducts.push(normalizedProduct);
      }

      return normalizedProducts;
    },
    [],
  );
};

export const useNormalizedProducts = (
  allProducts: AtlassianProductsFragment$data | null,
): NormalizedProduct[] => {
  const isProductIdToNodeIdChangeEnabled = productIdToNodeIdChangeIsActive();

  return useMemo(
    () =>
      allProducts
        ? getNormalizedProducts(allProducts, isProductIdToNodeIdChangeEnabled)
        : [],
    [allProducts, isProductIdToNodeIdChangeEnabled],
  );
};

export const useMapProducts = (
  selectedProducts: string,
  allProducts: NormalizedProduct[] | [],
): NormalizedProduct[] => {
  const selectedProductsArray = selectedProducts.split(',');

  return allProducts.filter((product) => {
    if (product && product.id) {
      if (selectedProductsArray.includes(product.id)) {
        return product;
      }
    }
  });
};
